module.exports = __webpack_public_path__ + "img/service_zecon 3.4efe9d6f.png";